import { normalizeLocationInfo } from '@utils/storeDataNormalization';
import countriesModuleFactory from '@helpers/storeFactories/moduleFactory';
import { apiService } from '@api';
import countriesWithHotels from './countriesWithHotels';

const STORE_NAME = 'countries';

const store = countriesModuleFactory.createModuleView(
    STORE_NAME,
    apiService,
    { customListFormatter: normalizeLocationInfo },
    {
        modules: {
            countriesWithHotels: countriesWithHotels,
        },
    }
);

export default store;
